import { useMutation } from "@tanstack/react-query";
import TenantAPI from "../../api/TenantAPI";
import { callFunctionIfExists } from "../../../utils/GeneralUtils";

const useBulkUpdateRecords = () => {
  const bulkUpdate = useMutation({
    mutationFn: ({
      moduleAPIName,
      recordIds,
      payload,
    }: {
      moduleAPIName: string;
      recordIds: string[];
      payload: any;
      onSuccess?: () => void;
    }) => {
      const finalPayload = {
        ids: recordIds,
        toUpdate: payload.Ids,
        _UserActivity: payload._UserActivity,
      };

      return TenantAPI.bulkUpdateRecords(moduleAPIName, finalPayload);
    },
    onSuccess: (_, { onSuccess }) => {
      callFunctionIfExists(onSuccess);
    },
  });

  return {
    bulkUpdate: bulkUpdate.mutate,
    startingUpdate: bulkUpdate.isPending,
  };
};

export default useBulkUpdateRecords;
